import styled from "styled-components";

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;

  @media screen and (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const P = styled.p`
  margin: 8px 0;
  align-items: center;
  display: flex;
  &.data-item-tempneedDescription {
    grid-column: span 2;
    width: 100%;
    max-width: 100%;
    align-items: start;
    flex-direction: column;
    p {
      margin: 0;
      max-width: 50%;
    }
  }
`;

export const CaseValue = styled.span`
  margin-left: 5px;
  font-weight: bold;
`;
